<template>
  <div class="popup">
    <div class="popup-inner">
      <div class="col-md-12">
        <div class="card card-container">
          <h3 class="subtitle is-4">Neues Passwort beantragen</h3>
          <Form >
            <v-responsive
                class="mx-auto"
                max-width="344"
            >
              <v-text-field
                  label="E-Mail"
                  v-model="this.email"
                  placeholder="Max"
                  type="text"
                  variant="outlined"
              />
            </v-responsive>

            <div v-if="this.accounts.length > 0">
              <v-select
                  v-model="selectedAccount"
                  :items="accounts"
                  :item-title="item => item.personalnummer + ', ' + item.companyName"
                  item-value="userId"
                  label="Account auswählen"
                  dense
                  outlined
              ></v-select>
            </div>

            <v-progress-linear
                v-if="sending && !this.message"
                color="green"
                height="4"
                indeterminate
                class="my-1"
            ></v-progress-linear>

            <div>
              <v-btn v-if="this.accounts.length === 0" @click="resetPasswordCheck()" class="mb-4"
                     style="background-color: var(--merkur-bg-color); color: white; width: 105px;" :disabled="this.sending">
                Abschicken
              </v-btn>
              <v-btn v-if="this.accounts.length > 0" @click="resetPassword()" class="mb-4"
                     style="background-color: var(--merkur-bg-color); color: white; width: 105px;" :disabled="this.sending">
                Abschicken
              </v-btn>
              <v-btn @click="close()" class="mb-4"
                     style="background-color: red; border: 3px solid red; color: white; float: right; width:105px;">
                Abbrechen
              </v-btn>
            </div>

            <div class="form-group">
              <div v-if="message" class="alert alert-danger" role="alert">
                {{ message }}
              </div>
            </div>
          </Form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import AuthService from "../services/auth.service";

export default {
  name: "ResetPWD",
  props: ['TogglePopup'],
  data() {
    return {
      email:"",
      message:"",
      accounts: [],
      selectedAccount: null,
      sending: false,
    };
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
  },
  methods: {
    close() {
      this.TogglePopup()
    },
    resetPasswordCheck(){
      let data = {
        email: this.email,
      }
      AuthService.resetPWDCheck(data).then(resp => {
        if(!resp.data || resp.data.length === 0) {
          this.accounts = [];
          this.sending = true;
          AuthService.resetPWD(this.email).then(() => {
            this.TogglePopup();
            this.sending = false;
          }).catch((e => {
            this.sending = false;
            this.message = ""
            if(e.response.data.errors) {
              e.response.data.errors.forEach(e => {
                this.message += e
              })
            }
            else {
              this.message = e.response.data.message
            }
          }));
        } else {
          this.accounts = resp.data;
        }

      }).catch((e => {
        this.message = ""
        if(e.response.data.errors) {
          e.response.data.errors.forEach(e => {
            this.message += e
          })
        }
        else {
          this.message = e.response.data.message
        }
      }));
    },
    resetPassword(){
      if(!this.selectedAccount) {
        this.message = "Bitte Account auswählen!"
        return;
      }
      this.sending = true;
      AuthService.resetPWD(this.email, this.selectedAccount).then(() => {
        this.TogglePopup();
        this.sending = false;
      }).catch((e => {
        this.sending = false;
        this.message = ""
        if(e.response.data.errors) {
          e.response.data.errors.forEach(e => {
            this.message += e
          })
        }
        else {
          this.message = e.response.data.message
        }
      }));
    },
  },
};
</script>

<style scoped>
.popup {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99;
  background-color: rgba(0, 0, 0, 0.5);

  display: flex;
  align-items: center;
  justify-content: center;
}

.popup-inner {
  padding: 64px;
  width: 500px;
}

label {
  display: block;
  margin-top: 10px;
}

.card-container.card {
  max-width: 450px !important;
  padding: 20px 30px;
}

.card {
  background-color: #f7f7f7;
  padding: 20px 25px 30px;
  -moz-border-radius: 2px;
  -webkit-border-radius: 2px;
  border-radius: 2px;
  -moz-box-shadow: 0 2px 2px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: 0 2px 2px rgba(0, 0, 0, 0.3);
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.3);
}
</style>